<div class="home-tabs-menu">
  <h1>Channel Navigator</h1>
  <div class="home-tabs-menu-body">
    <div class="home-tabs-item W172">

      <button [ngClass]="{'active' : visibleSection === 'TaSection'}" (click)="onSectionClick('TaSection')">TA
        <span class="MONT" *ngIf="tasFilterCountResume >= 0">{{tasFilterText}}
          <span class="MONT2" *ngIf="tasFilterCountResume > 0">+{{tasFilterCountResume}}</span>
        </span>
      </button>
      <button [ngClass]="{'active' : visibleSection === 'AssetSection'}" (click)="onSectionClick('AssetSection')">Asset
        <span class="MONT" *ngIf="assetsFilterCountResume >= 0">{{assetsFilterText}}
          <span class="MONT2" *ngIf="assetsFilterCountResume > 0">+{{assetsFilterCountResume}}</span>
        </span>
      </button>
      <button [ngClass]="{'active' : visibleSection === 'IndicationSection'}" (click)="onSectionClick('IndicationSection')">Indication
        <span class="MONT" *ngIf="indicationsFilterCountResume >= 0">{{indicationsFilterText}}
          <span class="MONT2" *ngIf="indicationsFilterCountResume > 0">+{{indicationsFilterCountResume}}</span>
        </span>
      </button>

      <div class="apply-filters-box H47">
        <button class="blank-btn" (click)="clearAllFilters()">
          <i class="icon icon-close top3 MR7"></i>Clear Filters</button>
      </div>
    </div>
    <div class="home-tabs-item W171">
      <div class="pos-rel">
        <ng-container *ngIf="visibleSection === 'TaSection'">
          <div class="center MB10 PT9">
            <input type="search" class="center" [(ngModel)]="taTxtFilter" placeholder="Search TA">
            <i class="search-input-icon"></i>
          </div>
          <div class="scroll-y  H223">
            <div class="form-check" *ngFor="let ta of filteredTAs" (click)="generalService?.selectedByTas(ta.Id); reloadSelectedFilters()">
              <input class="form-check-input" type="checkbox" value="{{ta?.Id}}" [checked]="generalService.isTaChecked(ta.Id)" id="TaCheckBox{{ta?.Id}}"
              />
              <label class="form-check-label" for="TaCheckBox{{ta?.Id}}">
                {{ta?.Title}}
              </label>
            </div>
          </div>

        </ng-container>
        <ng-container *ngIf="visibleSection === 'AssetSection'">
          <div class="center MB10 PT9">
            <input type="search" class="center" [(ngModel)]="assetTxtFilter" placeholder="Search Asset">
            <i class="search-input-icon"></i>
          </div>
          <div class="scroll-y H223">
            <div class="form-check" *ngFor="let asset of filteredAssets" (click)="generalService?.selectedByAssets(asset.Items)">
              <input class="form-check-input" type="checkbox" value="{{asset?.Title}}" [checked]="generalService.isAssetChecked(asset.Title)"
                id="{{getItemLabel(asset?.Title,'AssetCheckBox')}}" />
              <label class="form-check-label" for="{{getItemLabel(asset?.Title,'AssetCheckBox')}}">
                {{asset?.Title}}
              </label>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="visibleSection === 'IndicationSection'">
          <div class="center MB10 PT9">
            <input type="search" class="center" [(ngModel)]="indicationTxtFilter" placeholder="Search Indication">
            <i class="search-input-icon"></i>
          </div>
          <div class="scroll-y  H223">
            <div class="form-check" *ngFor="let indication of filteredIndications" (click)="generalService?.selectedByIndications(indication.Items)">
              <input class="form-check-input" type="checkbox" value="{{indication?.Title}}" [checked]="generalService.isIndicationChecked(indication.Title)"
                id="{{getItemLabel(indication?.Title,'IndicationCheckBox')}}" />
              <label class="form-check-label" for="{{getItemLabel(indication?.Title,'IndicationCheckBox')}}">
                {{indication?.Title}}
              </label>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="apply-filters-box H47">
        <button class="blank-btn" (click)="applyChannelFilters()">Apply Filters
          <i class="icon icon-right-arrow top5 ML7"></i>
        </button>
      </div>
    </div>
    <div class="home-tabs-item">
      <div class="H41 PT12">
        <h5 class="ML13 pos-rel">Channels
          <i class="icon-info ML7 top-3" popoverTitle="Filter your channels" popoverClass="popover-info" [autoClose]="'outside'" container="body"
            placement="right" [ngbPopover]="popContent">
            <!-- <i class="icon-info ML7 top-3" (click)="viewInfo = !viewInfo"> -->
            i
            <!-- <div class="channel-info-popover" [ngClass]="{'is-view' : viewInfo }">
              <h6 class="">Filter your channels</h6>
                 </div> -->
            <div class="arrow-info-popover"></div>
          </i>
        </h5>

      </div>
     <!-- <div class="channels-btns">
        <button [ngClass]="{'active' : channelType === 0}" (click)="channelType = 0">All</button>
        <button [ngClass]="{'active' : channelType === 1}" (click)="channelType = 1">Insights</button>
        <button [ngClass]="{'active' : channelType === 2}" (click)="channelType = 2">Submissions</button>
      </div>-->
      <div class="channels-list">
        <!--<ul *ngIf="loadingChannels === false">
          <li *ngFor="let channel of channels" (mouseenter)="showDescription(channel)" (mouseleave)="hideDescription()">
            <a *ngIf="channel" [ngClass]="{'new-text' : getNewLableVisible(channel)}" [routerLink]="getChannelURL(channel)" (click)="goToChannelComponent(channel)">{{channel?.Title}}</a>
          </li>
        </ul>
        <div class="home-tabs-loader" *ngIf="loadingChannels">
          <div class="loader"></div>
        </div>-->
     
        <div class="row">
          <div class="col">
              <ul *ngIf="loadingChannels === false">
                  <li *ngFor="let channel of channels; index as i" (mouseenter)="showDescription(channel)" (mouseleave)="hideDescription()">
                  <ng-container *ngIf="i < channels.length/2">
                    <a *ngIf="channel" [ngClass]="{'new-text' : getNewLableVisible(channel)}" [routerLink]="getChannelURL(channel)" (click)="goToChannelComponent(channel)">{{channel?.Title}}</a>
                  </ng-container>
                  </li>
              </ul>
          </div>
          <div class="col">
              <ul *ngIf="loadingChannels === false">
                  <li *ngFor="let channel of channels; index as i" (mouseenter)="showDescription(channel)" >
                    <ng-container *ngIf="i >= channels.length/2">
                      <a *ngIf="channel" [ngClass]="{'new-text' : getNewLableVisible(channel)}" [routerLink]="getChannelURL(channel)" (click)="goToChannelComponent(channel)">{{channel?.Title}}</a>
                    </ng-container>
                  </li>
              </ul>
          </div>
      </div>
      
      <div class="home-tabs-loader" *ngIf="loadingChannels">
        <div class="loader"></div>
      </div>
    </div>
    </div>
    <div class="home-tabs-item W205 H320 P0 channels-default">
      <ng-container *ngIf="!channelDescription">
        <div class="home-tabs-item-default-bg">
          <div class="">
            <i></i>
          </div>
          <div class="">
            <span class="">Hover over a channel name to see its description</span>
          </div>
        </div>
      </ng-container>
      <div class="channels-description" *ngIf="channelDescription">
        <div>
          <!-- <p>channelDescription</p> -->
          <p [innerHtml]="channelDescription"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #popContent>Too many to pick from? Pick a context by selecting TA, Asset and/or Indication and clicking the Filter Channels button at
  the bottom to identify channels most relevant to you.</ng-template>